import type { Theme, Components } from '@mui/material/styles';

import { menuItem } from '../../styles';

// ----------------------------------------------------------------------

/** Used by GridActionsCellItem variant="destructive". Spread on MenuItem for non-DataGrid usage: {...destructiveMenuItemProps} */
export const destructiveMenuItemProps = {
  'data-variant': 'destructive',
} as const;

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      ...menuItem(theme),
      /** Destructive variant: same pattern as disabled/selected – theme applies error color */
      '&[data-variant="destructive"]:not(.Mui-disabled)': {
        color: theme.vars.palette.error.main,
      },
    }),
  },
};

// ----------------------------------------------------------------------

export const menu = { MuiMenuItem };
